import API from "../axiosConfig";

export const getUserCriticalChanges = async (filters = {}) => {
  try {
    const params = {};
    if (filters.changed_by) params.changed_by = filters.changed_by;
    if (filters.start_date) params.start_date = filters.start_date;
    if (filters.end_date) params.end_date = filters.end_date;
    if (filters.model) params.model = filters.model;
    if (filters.model_id) params.model_id = filters.model_id;
    if (filters.per_page) params.per_page = filters.per_page;
    if (filters.page) params.page = filters.page;

    const response = await API.get("/user-critical-changes", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching user critical changes:", error);
    throw error;
  }
};